import { useMemo, type FC } from 'react';
import { Text, type TextProps } from '@highereducation/hen-ui';
import cn from '../../shared/utils/classNames';
import parseHtmlString from '../../shared/utils/parseHtmlString';
import {
  richTextContentClassName,
  richTextMarkupClassName,
} from './rich-text.variants';

export interface RichTextProps
  extends Pick<TextProps, 'variant' | 'color' | 'align' | 'weight'> {
  /** CMS HTML from Offerings snippets or Organization Marketing value props. */
  html: string;
  className?: string;
}

export const RichText: FC<RichTextProps> = ({
  html,
  variant = 'b4',
  color,
  align,
  weight,
  className,
}) => {
  const content = useMemo(() => parseHtmlString(html), [html]);

  if (content == null) {
    return null;
  }

  return (
    <Text
      tag='div'
      variant={variant}
      color={color}
      align={align}
      weight={weight}
      className={cn(
        richTextContentClassName,
        richTextMarkupClassName,
        className ?? '',
      )}
    >
      {content}
    </Text>
  );
};
